
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/emarsys",
      function () {
        return require("private-next-pages/destinations/emarsys.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/emarsys"])
      });
    }
  